import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { StaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, keywords, title }) {
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const metaDescription =
          description || data.site.siteMetadata.description
        return (
          <Helmet
            htmlAttributes={{
              lang,
            }}
            title={title}
            titleTemplate={`%s | ${data.site.siteMetadata.title}`}
            meta={[
              {
                name: `description`,
                content: metaDescription,
              },
              {
                property: `og:title`,
                content: title,
              },
              {
                property: `og:description`,
                content: metaDescription,
              },
              {
                property: `og:type`,
                content: `website`,
              },
              {
                name: `twitter:card`,
                content: `summary`,
              },
              {
                name: `twitter:creator`,
                content: data.site.siteMetadata.author,
              },
              {
                name: `twitter:title`,
                content: title,
              },
              {
                name: `twitter:description`,
                content: metaDescription,
              },
            ]
              .concat(
                keywords.length > 0
                  ? {
                      name: `keywords`,
                      content: keywords.join(`, `),
                    }
                  : []
              )
              .concat(meta)}
          >
          <script async src="https://www.googletagmanager.com/gtag/js?id=UA-7288145-1"></script>
          <script>
            {`
            window.dataLayer = window.dataLayer || []
            function gtag(){window.dataLayer.push(arguments)}
            gtag('js', new Date())
            gtag('config', 'UA-7288145-1')
            `}
          </script>
          <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-TCBL43L');`}
          </script>
          <script src="https://www.google.com/recaptcha/api.js?render=6LcQhMMUAAAAAN8mNHD4PWVgslWkFw_fFUht0cjo"></script>
          <script>
          {`function getReCaptcha() {
            grecaptcha.ready(function() {
            grecaptcha.execute('6LcQhMMUAAAAAN8mNHD4PWVgslWkFw_fFUht0cjo', {action: 'homepage'}).then(function(token) {
                window.localStorage.setItem('being_keys', token)
              })
            })
          }

          setTimeout(function() { getReCaptcha() }, 2000)
          setInterval(function() { getReCaptcha() }, 150000)`
          }
          </script>
          </Helmet>
        )
      }}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
}

export default SEO

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
      }
    }
  }
`
